<div [formGroup]="form"
     [class.dateErrors]="form.invalid"
     class="selected-date">

    <kal-form-field [displayErrors]="false" [class.gup-C-formFieldSize--bottomNull]="bottomNull" [class.without-label]="withoutLabel">

        <kal-input formControlName="day"
                   label="Jour"
                   type="number">
        </kal-input>

    </kal-form-field>

    <kal-form-field [displayErrors]="false" [class.gup-C-formFieldSize--bottomNull]="bottomNull" [class.without-label]="withoutLabel">

        <kal-input formControlName="month"
                   label="Mois"
                   type="number">
        </kal-input>

    </kal-form-field>

</div>
